/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
/**
 * HitApi - axios parameter creator
 * @export
 */
export const HitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Increment the visit count each time a user accesses the website.
         * @summary Record a website hit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHit: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HitApi - functional programming interface
 * @export
 */
export const HitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HitApiAxiosParamCreator(configuration)
    return {
        /**
         * Increment the visit count each time a user accesses the website.
         * @summary Record a website hit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postHit(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postHit(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HitApi.postHit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * HitApi - factory interface
 * @export
 */
export const HitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HitApiFp(configuration)
    return {
        /**
         * Increment the visit count each time a user accesses the website.
         * @summary Record a website hit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postHit(options?: any): AxiosPromise<void> {
            return localVarFp.postHit(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HitApi - object-oriented interface
 * @export
 * @class HitApi
 * @extends {BaseAPI}
 */
export class HitApi extends BaseAPI {
    /**
     * Increment the visit count each time a user accesses the website.
     * @summary Record a website hit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HitApi
     */
    public postHit(options?: RawAxiosRequestConfig) {
        return HitApiFp(this.configuration).postHit(options).then((request) => request(this.axios, this.basePath));
    }
}

